/* eslint-disable */
(function longformScript($, Drupal) {
  Drupal.behaviors.longform = {
    attach() {
      if ($('#more-information').length) {
        $('.info-links').find('.info-links__title').remove();
      }
    },
  };
}(jQuery, Drupal));
/* eslint-enable */
